<p>select-checkliste-dialog works!</p>
